// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1eDrr","buttons":"SendReceipts_buttons__2DdG9","email":"SendReceipts_email__1iLqy","bookApptTitle":"SendReceipts_bookApptTitle__2RETv"};